import React, { Component } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  CssBaseline, CircularProgress, Container, Button, Grid, Typography,
  Card, CardContent, CardActions, Chip, Divider, Stepper, Step, StepLabel,
  Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { Styles } from '../../styles/material-styles'
import { Overlay } from '../../styles/global'
import CustomizedSnackbars from '../../components/material-snackbars'
import HeaderMenu from '../../components/header-menu'
import Footer from '../../components/footer'
import { injectIntl } from 'react-intl'
import * as componentActions from '../../redux/actions/organizations'

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import {
  getAvailableProducts, getPlanPeriodicities,
  addProductToContract, getContractProducts, createCheckoutSession
} from '../../services/subscription.service'

class AddProduct extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      hirerId: 0,

      activeStep: 0,
      availableProducts: [],
      contractedProductIds: [],
      selectedProduct: null,
      planPeriodicities: [],
      selectedPlanPeriodicity: null,
      groupedPlans: [],
      selectedPlanId: 0,
      filteredPeriodicities: [],

      confirmDialogOpen: false,
      processing: false,
    }

    this.closeNotification = this.closeNotification.bind(this)
  }

  async componentDidMount() {
    const hirerId = this.props.userSession && this.props.userSession.user
      ? this.props.userSession.user.hirerid
      : 0

    if (hirerId) {
      this.setState({ hirerId, loading: true })
      await this.loadData(hirerId)
      this.setState({ loading: false })
    }
  }

  async loadData(hirerId) {
    try {
      const [productsResult, contractedResult] = await Promise.all([
        getAvailableProducts(),
        getContractProducts(hirerId)
      ])

      let availableProducts = []
      if (productsResult && productsResult.data && productsResult.data.data) {
        availableProducts = Array.isArray(productsResult.data.data)
          ? productsResult.data.data
          : []
      }

      let contractedProductIds = []
      if (contractedResult && contractedResult.data && contractedResult.data.data) {
        const contracted = Array.isArray(contractedResult.data.data)
          ? contractedResult.data.data
          : []
        contractedProductIds = contracted.map(p => p.applicationid || p.applicationId)
      }

      this.setState({ availableProducts, contractedProductIds })
    } catch (err) {
      console.error('Error loading data:', err)
    }
  }

  async loadPlanPeriodicities(applicationId) {
    this.setState({ loading: true })
    try {
      const result = await getPlanPeriodicities(applicationId)
      if (result && result.data && result.data.data) {
        const allPp = Array.isArray(result.data.data) ? result.data.data : []
        const planMap = {}
        allPp.forEach(pp => {
          const pId = pp.planid ?? pp.planId ?? 0
          const pName = pp.planname ?? pp.planName ?? '-'
          if (!planMap[pId]) planMap[pId] = { id: pId, name: pName, periodicities: [] }
          planMap[pId].periodicities.push(pp)
        })
        this.setState({ planPeriodicities: allPp, groupedPlans: Object.values(planMap), selectedPlanId: 0, filteredPeriodicities: [] })
      }
    } catch (err) {
      console.error('Error loading plan periodicities:', err)
    }
    this.setState({ loading: false })
  }

  handleSelectProduct = async (product) => {
    const productId = product.id
    this.setState({ selectedProduct: product, activeStep: 1 })
    await this.loadPlanPeriodicities(productId)
  }

  handleSelectPlanGroup = async (plan) => {
    const appId = this.state.selectedProduct ? this.state.selectedProduct.id : 0
    this.setState({ selectedPlanId: plan.id, filteredPeriodicities: [], selectedPlanPeriodicity: null, loading: true })
    const result = await getPlanPeriodicities(appId, plan.id)
    if (result && result.data && result.data.data) {
      const periodicities = Array.isArray(result.data.data) ? result.data.data : []
      this.setState({ filteredPeriodicities: periodicities, loading: false })
    } else {
      this.setState({ filteredPeriodicities: plan.periodicities, loading: false })
    }
  }

  handleSelectPeriodicity = (pp) => {
    this.setState({ selectedPlanPeriodicity: pp, activeStep: 2 })
  }

  handleBack = () => {
    const { activeStep } = this.state
    if (activeStep === 1) {
      this.setState({ activeStep: 0, selectedProduct: null, planPeriodicities: [], selectedPlanPeriodicity: null })
    } else if (activeStep === 2) {
      this.setState({ activeStep: 1, selectedPlanPeriodicity: null })
    }
  }

  handleConfirmAdd = async () => {
    const { hirerId, selectedProduct, selectedPlanPeriodicity } = this.state
    const intl = this.props.intl

    this.setState({ processing: true, confirmDialogOpen: false })

    const applicationId = selectedProduct.id
    const planPeriodicityId = selectedPlanPeriodicity.id

    const result = await addProductToContract(hirerId, applicationId, planPeriodicityId)

    if (result && result.data && result.data.success !== false) {
      this.setState({
        processing: false,
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: intl.formatMessage({ id: 'add.product.success' }),
        activeStep: 0,
        selectedProduct: null,
        selectedPlanPeriodicity: null,
        planPeriodicities: [],
      })
      await this.loadData(hirerId)
    } else {
      this.setState({
        processing: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.errors
          ? result.data.errors[0]
          : intl.formatMessage({ id: 'add.product.error' }),
      })
    }
  }

  formatCurrency(value, currency) {
    if (value == null) return '-'
    const cur = currency || 'BRL'
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cur }).format(value)
  }

  closeNotification() {
    this.setState({ openNotification: false })
  }

  renderProductSelection() {
    const intl = this.props.intl
    const { availableProducts, contractedProductIds } = this.state

    const uncontracted = availableProducts.filter(
      p => !contractedProductIds.includes(p.id)
    )

    const backButton = (
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => this.props.history.push(`/${this.props.match.params.lang}/subscription-management`, { defaultTab: 1 })}
        style={{ marginBottom: 16, textTransform: 'none' }}
      >
        {intl.formatMessage({ id: "back" })}
      </Button>
    )

    if (uncontracted.length === 0) {
      return (
        <div style={{ marginTop: 20 }}>
          {backButton}
          <Card elevation={2} style={{ textAlign: 'center', padding: 40 }}>
          <CardContent>
            <CheckCircleIcon style={{ fontSize: 64, color: '#4caf50', marginBottom: 16 }} />
            <Typography variant="h6">
              {intl.formatMessage({ id: 'add.product.all.contracted' })}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {intl.formatMessage({ id: 'add.product.all.contracted.description' })}
            </Typography>
          </CardContent>
        </Card>
        </div>
      )
    }

    return (
      <div style={{ marginTop: 8 }}>
        {backButton}
        <Grid container spacing={3}>
        {uncontracted.map((product, idx) => {
          const name = product.name || '-'
          return (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Card
                elevation={2}
                style={{ cursor: 'pointer', transition: 'box-shadow 0.2s' }}
                onClick={() => this.handleSelectProduct(product)}
                onMouseOver={(e) => e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.15)'}
                onMouseOut={(e) => e.currentTarget.style.boxShadow = ''}
              >
                <CardContent style={{ textAlign: 'center', padding: 24 }}>
                  <ShoppingCartIcon style={{ fontSize: 48, color: '#8BC34A', marginBottom: 12 }} />
                  <Typography variant="h6" style={{ fontWeight: 600 }}>{name}</Typography>
                </CardContent>
                <CardActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                  <Button
                    size="small"
                    variant="outlined"
                    style={{ textTransform: 'none', color: '#8BC34A', borderColor: '#8BC34A' }}
                  >
                    {intl.formatMessage({ id: 'add.product.select' })}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          )
        })}
      </Grid>
      </div>
    )
  }

  renderPlanSelection() {
    const intl = this.props.intl
    const { planPeriodicities, selectedProduct } = this.state
    const productName = selectedProduct ? selectedProduct.name : ''

    return (
      <div style={{ marginTop: 20 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={this.handleBack}
          style={{ marginBottom: 16, textTransform: 'none' }}
        >
          {intl.formatMessage({ id: 'add.product.back.products' })}
        </Button>

        <Typography variant="h6" style={{ marginBottom: 16 }}>
          {intl.formatMessage({ id: 'add.product.select.plan.for' })} <strong>{productName}</strong>
        </Typography>

        {this.state.groupedPlans.length === 0 ? (
          <Typography color="textSecondary">{intl.formatMessage({ id: 'add.product.no.plans' })}</Typography>
        ) : (
          <>
            {/* Plan Selection */}
            <Typography variant="caption" style={{ fontWeight: 700, color: '#757575', textTransform: 'uppercase', letterSpacing: 1 }}>
              {intl.formatMessage({ id: 'subscription.plan.name' })}
            </Typography>
            <div style={{ display: 'flex', gap: 12, marginTop: 8, marginBottom: 24, flexWrap: 'wrap' }}>
              {this.state.groupedPlans.map((plan, idx) => {
                const isSelected = this.state.selectedPlanId === plan.id
                return (
                  <Card key={idx} elevation={isSelected ? 4 : 1}
                    style={{ flex: '1 1 0', minWidth: 120, cursor: 'pointer', border: isSelected ? '2px solid #8BC34A' : '1px solid #e0e0e0', transition: 'all 0.2s' }}
                    onClick={() => this.handleSelectPlanGroup(plan)}
                  >
                    <CardContent style={{ textAlign: 'center', padding: '16px 12px' }}>
                      <Typography variant="subtitle1" style={{ fontWeight: 600, color: isSelected ? '#8BC34A' : '#212121' }}>{plan.name}</Typography>
                    </CardContent>
                  </Card>
                )
              })}
            </div>

            {/* Periodicity Selection */}
            {this.state.filteredPeriodicities.length > 0 && (
              <>
                <Typography variant="caption" style={{ fontWeight: 700, color: '#757575', textTransform: 'uppercase', letterSpacing: 1 }}>
                  {intl.formatMessage({ id: 'subscription.periodicity' })}
                </Typography>
                <Grid container spacing={2} style={{ marginTop: 8 }}>
                  {this.state.filteredPeriodicities.map((pp, idx) => {
                    const periodicityName = pp.periodicityname || pp.periodicityName || '-'
                    const price = pp.planvaluepermonth || pp.planValuePerMonth
                    const agents = pp.agentlimitquantity || pp.agentLimitQuantity
                    const attendances = pp.attendancelimitpermonth || pp.attendanceLimitPerMonth

                    return (
                      <Grid item xs={12} sm={6} md={4} key={idx}>
                        <Card elevation={2} style={{ height: '100%', display: 'flex', flexDirection: 'column', cursor: 'pointer', border: '1px solid #e0e0e0', transition: 'all 0.2s' }}
                          onClick={() => this.handleSelectPeriodicity(pp)}
                        >
                          <CardContent style={{ flex: 1 }}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
                              {periodicityName}
                            </Typography>
                            <Typography variant="h5" style={{ fontWeight: 700, color: '#212121', marginBottom: 12 }}>
                              {this.formatCurrency(price)}
                              <Typography variant="caption" color="textSecondary"> /mês</Typography>
                            </Typography>
                            <Divider style={{ marginBottom: 12 }} />
                            {agents != null && (
                              <Typography variant="body2" style={{ marginBottom: 4 }}>
                                <CheckCircleIcon style={{ fontSize: 16, color: '#4caf50', verticalAlign: 'middle', marginRight: 4 }} />
                                {agents} {intl.formatMessage({ id: 'add.product.agents' })}
                              </Typography>
                            )}
                            {attendances != null && (
                              <Typography variant="body2" style={{ marginBottom: 4 }}>
                                <CheckCircleIcon style={{ fontSize: 16, color: '#4caf50', verticalAlign: 'middle', marginRight: 4 }} />
                                {attendances} {intl.formatMessage({ id: 'add.product.attendances' })}
                              </Typography>
                            )}
                          </CardContent>
                          <CardActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                            <Button
                              variant="contained"
                              style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none', fontWeight: 600 }}
                            >
                              {intl.formatMessage({ id: 'add.product.choose.plan' })}
                            </Button>
                          </CardActions>
                        </Card>
                      </Grid>
                    )
                  })}
                </Grid>
              </>
            )}
          </>
        )}
      </div>
    )
  }

  renderSummary() {
    const intl = this.props.intl
    const { selectedProduct, selectedPlanPeriodicity } = this.state

    const productName = selectedProduct ? selectedProduct.name : '-'
    const planName = selectedPlanPeriodicity
      ? (selectedPlanPeriodicity.planname || selectedPlanPeriodicity.planName || '-')
      : '-'
    const periodicityName = selectedPlanPeriodicity
      ? (selectedPlanPeriodicity.periodicityname || selectedPlanPeriodicity.periodicityName || '-')
      : '-'
    const price = selectedPlanPeriodicity
      ? (selectedPlanPeriodicity.planvaluepermonth || selectedPlanPeriodicity.planValuePerMonth)
      : null

    return (
      <div style={{ marginTop: 20 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={this.handleBack}
          style={{ marginBottom: 16, textTransform: 'none' }}
        >
          {intl.formatMessage({ id: 'add.product.back.plans' })}
        </Button>

        <Card elevation={3} style={{ maxWidth: 500, margin: '0 auto' }}>
          <CardContent style={{ padding: 24 }}>
            <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 16 }}>
              {intl.formatMessage({ id: 'add.product.summary' })}
            </Typography>

            <Divider style={{ marginBottom: 16 }} />

            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  {intl.formatMessage({ id: 'add.product.col.product' })}
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 500 }}>{productName}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  {intl.formatMessage({ id: 'add.product.col.plan' })}
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 500 }}>{planName}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  {intl.formatMessage({ id: 'add.product.col.periodicity' })}
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 500 }}>{periodicityName}</Typography>
              </Grid>
            </Grid>

            <div style={{
              marginTop: 20, padding: 16,
              backgroundColor: '#f1f8e9', borderRadius: 8, textAlign: 'center'
            }}>
              <Typography variant="caption" color="textSecondary">
                {intl.formatMessage({ id: 'add.product.monthly.value' })}
              </Typography>
              <Typography variant="h4" style={{ fontWeight: 700, color: '#33691e' }}>
                {this.formatCurrency(price)}
              </Typography>
            </div>
          </CardContent>
          <CardActions style={{ justifyContent: 'center', padding: 16 }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<ShoppingCartIcon />}
              onClick={() => this.setState({ confirmDialogOpen: true })}
              style={{
                backgroundColor: '#8BC34A', color: '#fff',
                textTransform: 'none', fontWeight: 600, paddingLeft: 32, paddingRight: 32
              }}
            >
              {intl.formatMessage({ id: 'add.product.confirm' })}
            </Button>
          </CardActions>
        </Card>
      </div>
    )
  }

  render() {
    const { classes, headerMenu } = this.props
    const intl = this.props.intl
    const { activeStep, loading, processing } = this.state

    const steps = [
      intl.formatMessage({ id: 'add.product.step.product' }),
      intl.formatMessage({ id: 'add.product.step.plan' }),
      intl.formatMessage({ id: 'add.product.step.confirm' }),
    ]

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='lg' style={{ paddingLeft: 24 }}>
            <CssBaseline />

            <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 4 }}>
              {intl.formatMessage({ id: 'add.product.title' })}
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 20 }}>
              {intl.formatMessage({ id: 'add.product.subtitle' })}
            </Typography>

            <Stepper activeStep={activeStep} style={{ marginBottom: 24 }}>
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            {loading && (
              <div style={{ textAlign: 'center', padding: 40 }}>
                <CircularProgress />
              </div>
            )}

            {!loading && activeStep === 0 && this.renderProductSelection()}
            {!loading && activeStep === 1 && this.renderPlanSelection()}
            {!loading && activeStep === 2 && this.renderSummary()}

          </Container>
          <Footer />
        </main>

        {/* Confirm Dialog */}
        <Dialog
          open={this.state.confirmDialogOpen}
          onClose={() => this.setState({ confirmDialogOpen: false })}
          maxWidth="xs"
        >
          <DialogTitle>{intl.formatMessage({ id: 'add.product.confirm.title' })}</DialogTitle>
          <DialogContent>
            <Typography>{intl.formatMessage({ id: 'add.product.confirm.message' })}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ confirmDialogOpen: false })}>
              {intl.formatMessage({ id: 'cancel' })}
            </Button>
            <Button
              onClick={this.handleConfirmAdd}
              variant="contained"
              disabled={processing}
              style={{ backgroundColor: '#8BC34A', color: '#fff' }}
            >
              {processing ? <CircularProgress size={24} /> : intl.formatMessage({ id: 'add.product.confirm.button' })}
            </Button>
          </DialogActions>
        </Dialog>

        <CustomizedSnackbars
          variant={this.state.notificationVariant}
          message={this.state.notificationMessage}
          isOpen={this.state.openNotification}
          toClose={this.closeNotification}
        />

        {processing && (
          <Overlay>
            <CircularProgress color="secondary" />
          </Overlay>
        )}
      </div>
    )
  }
}

AddProduct.propTypes = {}

const mapStateToProps = state => ({
  userSession: state.userSession,
  headerMenu: state.headerMenu,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AddProduct)))
